import { render, staticRenderFns } from "./Pagination-v2.vue?vue&type=template&id=64f3514e"
import script from "./Pagination-v2.vue?vue&type=script&lang=js"
export * from "./Pagination-v2.vue?vue&type=script&lang=js"
import style0 from "./Pagination-v2.vue?vue&type=style&index=0&id=64f3514e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports